import 'core-js'

import ReactDOM from 'react-dom'

import createDashboard from '@stackhouse/dashboard-components/Dashboard'

import { InitialPages } from './pages'
import UserInfo from './components/UserInfo'

import isMobile from './utils/is-mobile'
import handleAPIError from './utils/api-error'


const dashboardConfig = {
    pages: InitialPages,
    api: {
        baseURL: 'https://r3teamsmartapi.ramcube.it/api', //'https://localhost:44309/api', 
        //[SWAGGER] https://r3teamsmartapi.ramcube.it/swagger/index.html
        headers: {
            'X-Device-Mobile': isMobile
        },
        interceptors: {
            request: [
                (dashboard, config) => {
                    if (config.method.toUpperCase() == 'DELETE') {
                        config.headers = {
                            ...config.headers,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                        config.data = config.data || JSON.stringify({})
                    }
                    return config
                },
                (dashboard, error) => {
                    return Promise.reject(error)
                }
            ],
            response: [
                (dashboard, response) => {
                    return response
                },
                (dashboard, error) => {
                    return handleAPIError(dashboard, error)
                }
            ]
        }
    },
    settings: {
        login: {
            logo: require('./assets/logo.png'),
            background: 'https://images.unsplash.com/photo-1488952467585-b273b0f9d565?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2855&q=80'
        },
        select: {
            disableInitialSet: true,
            barcodeScan: isMobile,
            urlTemplate: '/select/{{table}}'
        },
        navbar: {
            user: {
                render: UserInfo
            },
        },
        drawer: {
            logo: require('./assets/logo.png')
        },
    },
    rootStyle: `
        @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700,900&display=swap&subset=cyrillic,latin-ext');
    `,
    theme: {
        fontSize: '13px',
        fontSizes: {
            text: '13px',
            input: '13px',
            label: '11px',
        },
        fontFamily: `'Source Sans Pro', sans-serif`,
        colors: {
            primary: '#279f39',
            background: 'white',
            text: '#2d2d2d',
            success: '#679c3d',
            info: '#cccccc',
            error: '#ba0000',
            warning: '#edce38',
            disabled: '#f8f8f8',
            border: '#cccccc',
            shadow: '#bbbbbb',
            lightGrey: '#dddddd',
            button: {
                text: 'white',
            },
            tooltip: {
                text: '#f3f3f3',
                background: '#626262',
            }
        }
    }
}

ReactDOM.render(createDashboard(dashboardConfig), document.getElementById('root'))